import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export class AdvanceDocument {
  @IsString()
  @Expose()
  documentId!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  contractorName!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  leftGross!: number;
  @IsNumber()
  @Expose()
  leftGrossInCurrency!: number;
  @IsString()
  @Expose()
  currency!: string;
  @Type(() => AdvanceDocument)
  @ValidateNested()
  @Expose()
  documentCorrection!: Array<AdvanceDocument>;
}

export class AdvanceDocumentsList extends GenericTableResponse<AdvanceDocument> {
  @Type(() => AdvanceDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<AdvanceDocument>;
}
